var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebhookSecret = function SvgWebhookSecret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11954_31874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84848 7.73525C7.99448 7.88125 7.99448 8.11925 7.84848 8.26525C7.70248 8.41125 7.46448 8.41125 7.31848 8.26525C7.17248 8.11925 7.17248 7.88125 7.31848 7.73525C7.46448 7.58825 7.70148 7.58825 7.84848 7.73525Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2645 7.73525C12.4105 7.88125 12.4105 8.11925 12.2645 8.26525C12.1185 8.41125 11.8805 8.41125 11.7345 8.26525C11.5885 8.11925 11.5885 7.88125 11.7345 7.73525C11.8805 7.58825 12.1185 7.58825 12.2645 7.73525Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6825 7.73525C16.8285 7.88125 16.8285 8.11925 16.6825 8.26525C16.5365 8.41125 16.2985 8.41125 16.1525 8.26525C16.0065 8.11925 16.0065 7.88125 16.1525 7.73525C16.2985 7.58825 16.5355 7.58825 16.6825 7.73525Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13H5C3.895 13 3 12.105 3 11V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V8",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3928 15.696V13.962C19.3928 12.878 18.5138 11.999 17.4298 11.999C16.3458 11.999 15.4668 12.878 15.4668 13.962V15.696",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.6982H15C14.448 15.6982 14 16.1462 14 16.6982V20.0002C14 20.5522 14.448 21.0002 15 21.0002H20C20.552 21.0002 21 20.5522 21 20.0002V16.6982C21 16.1452 20.552 15.6982 20 15.6982Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11954_31874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgWebhookSecret as ReactComponent };
export default __webpack_public_path__ + "webhook-secret.svg";